import {useState} from "react";
import {changeApnFormInitialState} from "./ChangeApnHelper";
import {apnTypeEnum, DEFAULT_APN_NAME} from "./initial-step/InitialStepHelper";

export const useModifyApnForm = (condivisoApnNames, condivisoVrfNames, dedicatoApnNames, sicurezzaCentralizzataApnNames) => {
    const [changeApnForm, setChangeApnForm] = useState(changeApnFormInitialState)

    // If something has only 1 option available, it has to be preselected
    const handleApnChangeForm = (e, name) => {
        if (name === "apnType" && e.target.value === apnTypeEnum.SICUREZZA_CENTRALIZZATA) {
            if (sicurezzaCentralizzataApnNames.length === 1) {
                setChangeApnForm({
                    ...changeApnForm,
                    [name]: e.target.value,
                    apnName: sicurezzaCentralizzataApnNames[0].value,
                    vrfName: ""
                })
            } else {
                setChangeApnForm({...changeApnForm, [name]: e.target.value, apnName: DEFAULT_APN_NAME, vrfName: ""})
            }
            return;
        }
        if (name === "apnType" && e.target.value !== apnTypeEnum.CONDIVISO) {
            if (e.target.value === apnTypeEnum.DEDICATO && dedicatoApnNames.length === 1) {
                setChangeApnForm({
                    ...changeApnForm,
                    [name]: e.target.value,
                    apnName: dedicatoApnNames[0].value,
                    vrfName: ""
                })
            } else {
                setChangeApnForm({...changeApnForm, [name]: e.target.value, apnName: "", vrfName: ""})
            }
            return;
        }
        if (name === "apnType" && e.target.value === apnTypeEnum.CONDIVISO) {
            if (condivisoVrfNames.length === 1) {
                setChangeApnForm({
                    ...changeApnForm,
                    [name]: e.target.value,
                    apnName: DEFAULT_APN_NAME,
                    vrfName: condivisoVrfNames[0].value
                })
            } else {
                setChangeApnForm({...changeApnForm, [name]: e.target.value, apnName: DEFAULT_APN_NAME, vrfName: ""})
            }
            return;
        }
        setChangeApnForm({...changeApnForm, [name]: e.target.value})
    }

    return [changeApnForm, handleApnChangeForm]
}